import 'bootstrap';
import 'filepond/dist/filepond.min.css';
import 'jquery';
import 'popper.js';
import React from 'react';
import { Provider } from 'react-redux';
import '../node_modules/@fortawesome/fontawesome-pro/css/all.css';
import '../node_modules/leaflet-draw/dist/leaflet.draw.css';
import '../node_modules/leaflet-easybutton/src/easy-button.css';
import '../node_modules/leaflet/dist/leaflet.css';
import './config/ReactotronConfig';
import Routes from './routes';
import store from './store';
import './styles/main.scss';


const App = () => (
	<Provider store={store}>
		<Routes />
	</Provider>
);

export default App;
